(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 30677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(94739);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Hc": function() { return /* binding */ iskibrisstrapi; }
});

// UNUSED EXPORTS: getArticles, getCategories, getRecentArticles, getSingleArticle, getSingleCategory, getSingleCategoryArticles, getTestimonials

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/api/strapi/client.js

var api = axios_default().create({
    baseURL: "https://strapi.iskibris.com",
    headers: {
        Accept: "application/json"
    }
});
api.interceptors.request.use(function(request) {
    return request;
});
api.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    console.log("Api Response Error: ", error);
    return Promise.reject(error);
});
/* harmony default export */ var client = (api);

;// CONCATENATED MODULE: ./src/api/strapi/strapi.js

function getArticles() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, perPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
    return client.get("/api/articles?populate=image,author&pagination[page]=".concat(page, "&pagination[pageSize]=").concat(perPage, "&sort[0]=createdAt:desc"));
}
function getSingleArticle(id) {
    return client.get("/api/articles/".concat(id, "?populate=image,author"));
}
function getTestimonials() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, perPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
    return client.get("/api/testimonials?populate=image&pagination[page]=".concat(page, "&pagination[pageSize]=").concat(perPage, "&sort[0]=createdAt:desc"));
}
function getRecentArticles() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, perPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
    return client.get("/api/articles?populate=image,author&pagination[page]=".concat(page, "&pagination[pageSize]=").concat(perPage, "&sort[0]=createdAt:desc"));
}
function getCategories() {
    var page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, perPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 12;
    return client.get("/api/categories?pagination[page]=".concat(page, "&pagination[pageSize]=").concat(perPage));
}
function getSingleCategory(id) {
    return client.get("/api/categories/".concat(id));
}
function getSingleCategoryArticles(slug) {
    var page = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, perPage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 12;
    return client.get("/api/articles?populate=image,author&filters[category][slug][$eq]=".concat(slug, "&pagination[page]=").concat(page, "&pagination[pageSize]=").concat(perPage, "&sort[0]=createdAt:desc"));
}
var iskibrisstrapi = {
    getSingleCategoryArticles: getSingleCategoryArticles,
    getArticles: getArticles,
    getSingleArticle: getSingleArticle,
    getTestimonials: getTestimonials,
    getCategories: getCategories,
    getRecentArticles: getRecentArticles,
    getSingleCategory: getSingleCategory
};


/***/ }),

/***/ 74944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArticleListItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);



function ArticleListItem(param) {
    var article = param.article;
    var ref, ref1, ref2;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        as: "/blog/".concat(article === null || article === void 0 ? void 0 : (ref = article.attributes) === null || ref === void 0 ? void 0 : ref.slug, "?id=").concat(article === null || article === void 0 ? void 0 : article.id),
        href: "/blog/[slug]",
        className: "article-list-item ",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "article-list-item",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        id: "category",
                        className: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "icon icon-2 far fa-long-arrow-right"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        id: "title",
                        className: "article-list-item__title link",
                        children: article === null || article === void 0 ? void 0 : (ref1 = article.attributes) === null || ref1 === void 0 ? void 0 : ref1.title
                    })
                ]
            })
        })
    }, article === null || article === void 0 ? void 0 : (ref2 = article.attributes) === null || ref2 === void 0 ? void 0 : ref2.slug));
};


/***/ }),

/***/ 60249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94803);
/* harmony import */ var react_moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11557);
/* harmony import */ var moment_locale_tr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72397);
/* harmony import */ var moment_locale_tr__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment_locale_tr__WEBPACK_IMPORTED_MODULE_4__);






var BlogCard = function(param) {
    var article = param.article;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var locale =  true ? window.localStorage.i18nextLng : 0;
    var imageUrl;
    if (article === null || article === void 0 ? void 0 : (ref = article.attributes) === null || ref === void 0 ? void 0 : ref.image) {
        var ref14;
        imageUrl = (0,_utils_api__WEBPACK_IMPORTED_MODULE_5__/* .getStrapiMedia */ .$)(article === null || article === void 0 ? void 0 : (ref14 = article.attributes) === null || ref14 === void 0 ? void 0 : ref14.image);
    } else {
        imageUrl = "/assets/images/blog-post-image-placeholder.jpeg";
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
        as: "/blog/".concat(article === null || article === void 0 ? void 0 : (ref1 = article.attributes) === null || ref1 === void 0 ? void 0 : ref1.slug, "?id=").concat(article === null || article === void 0 ? void 0 : article.id),
        href: "/blog/[id]",
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "card",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "card__inner",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                as: "/blog/".concat(article === null || article === void 0 ? void 0 : (ref2 = article.attributes) === null || ref2 === void 0 ? void 0 : ref2.slug, "?id=").concat(article === null || article === void 0 ? void 0 : article.id),
                                href: "/blog/[id]",
                                children: imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : "/acapulco.png",
                                    width: "100%",
                                    style: {
                                        cursor: "pointer",
                                        height: "auto"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "icon icon-2 far fa-long-arrow-right"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "title",
                                className: "card__title",
                                children: article === null || article === void 0 ? void 0 : (ref3 = article.attributes) === null || ref3 === void 0 ? void 0 : ref3.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "card__meta",
                                children: [
                                    (article === null || article === void 0 ? void 0 : (ref4 = article.attributes) === null || ref4 === void 0 ? void 0 : ref4.author) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            article === null || article === void 0 ? void 0 : (ref5 = article.attributes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.author) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.name,
                                            " | "
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_moment__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        format: "Do MMMM, YYYY dddd",
                                        className: "card__date",
                                        locale: locale,
                                        children: article === null || article === void 0 ? void 0 : (ref9 = article.attributes) === null || ref9 === void 0 ? void 0 : ref9.created_at
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "card__description",
                                children: article === null || article === void 0 ? void 0 : (ref10 = article.attributes) === null || ref10 === void 0 ? void 0 : ref10.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                as: "/blog/".concat(article === null || article === void 0 ? void 0 : (ref11 = article.attributes) === null || ref11 === void 0 ? void 0 : ref11.slug, "?id=").concat(article === null || article === void 0 ? void 0 : article.id),
                                href: "/blog/[id]",
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "link link--text card__link",
                                    children: "Okumaya devam et"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    className: "card__divider"
                })
            ]
        }, article === null || article === void 0 ? void 0 : (ref12 = article.attributes) === null || ref12 === void 0 ? void 0 : ref12.slug)
    }, article === null || article === void 0 ? void 0 : (ref13 = article.attributes) === null || ref13 === void 0 ? void 0 : ref13.slug));
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 32283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77297);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66278);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87357);




var Layout = function(param) {
    var children = param.children, categories = param.categories, seo = param.seo;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "auto"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                flexGrow: 1,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 94739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_lab__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13316);
/* harmony import */ var _material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82633);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51907);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95477);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32283);
/* harmony import */ var _components_BlogCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60249);
/* harmony import */ var _components_ArticleListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74944);
/* harmony import */ var _api_strapi_strapi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13548);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _throw(e) {
    throw e;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Blog = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var ref9 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(null), 2), cartArticles = ref9[0], setCartArticles = ref9[1];
    var ref1 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(12), 1), rowsPerPage = ref1[0];
    var ref2 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(1), 2), pagiPage = ref2[0], setPage = ref2[1];
    var ref3 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(undefined), 2), lastPage = ref3[0], setLastPage = ref3[1];
    var ref4 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), fetchError = ref4[0], setFetchError = ref4[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        _api_strapi_strapi__WEBPACK_IMPORTED_MODULE_5__/* .iskibrisstrapi.getArticles */ .Hc.getArticles(pagiPage, rowsPerPage).then(function(response) {
            var ref, ref5, ref6, ref7;
            setCartArticles((ref = response.data) === null || ref === void 0 ? void 0 : ref.data);
            var ref8;
            setLastPage(Math.ceil(((ref8 = (ref5 = response.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.pagination) === null || ref7 === void 0 ? void 0 : ref7.total) !== null && ref8 !== void 0 ? ref8 : 0) / rowsPerPage));
        }).catch(function(err) {
            console.log("Error fetching articles: ", err);
            setFetchError(true);
        });
    }, [
        pagiPage,
        rowsPerPage
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pt-4 mt-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "wrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "headline--centered",
                        children: "Blog"
                    })
                })
            }),
            cartArticles ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                container: true,
                className: "content--with-banner-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 4,
                        lg: 4,
                        children: cartArticles.map(function(article, i) {
                            var ref;
                            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ArticleListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                article: article
                            }, "article__left__".concat(article === null || article === void 0 ? void 0 : (ref = article.attributes) === null || ref === void 0 ? void 0 : ref.slug)));
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 8,
                        children: [
                            cartArticles// .slice((pagiPage - 1) * rowsPerPage, (pagiPage - 1) * rowsPerPage + rowsPerPage)
                            .map(function(article, i) {
                                var ref, ref10;
                                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            article: article
                                        }, "article__left__".concat(article === null || article === void 0 ? void 0 : (ref = article.attributes) === null || ref === void 0 ? void 0 : ref.slug)),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {})
                                    ]
                                }, article === null || article === void 0 ? void 0 : (ref10 = article.attributes) === null || ref10 === void 0 ? void 0 : ref10.slug));
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                style: {
                                    justifyContent: "center",
                                    marginTop: "15px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    count: lastPage,
                                    color: "primary",
                                    page: pagiPage,
                                    onChange: function(event, value) {
                                        setPage(value);
                                    }
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: "100%"
                },
                children: fetchError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        severity: "error",
                        style: {
                            width: "80%"
                        },
                        children: "Blog g\xf6nderileri getirilirken hata oluştu. Ağ bağlantınızı kontrol edin ve tekrar deneyin."
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Blog);


/***/ }),

/***/ 11557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getStrapiMedia; }
/* harmony export */ });
/* unused harmony export getStrapiURL */
function getStrapiURL() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return encodeURI("".concat("https://strapi.iskibris.com" || 0).concat(path));
}
function getStrapiMedia(media) {
    var ref, ref1;
    if (media == null) {
        return null;
    }
    var mediaUrl = media === null || media === void 0 ? void 0 : (ref = media.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.url;
    var imageUrl = (mediaUrl === null || mediaUrl === void 0 ? void 0 : mediaUrl.startsWith("/")) ? getStrapiURL(mediaUrl) : mediaUrl;
    return imageUrl;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,722,951,865,803,111,795,774,888,179], function() { return __webpack_exec__(30677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);